import { BaseEntityInfoUtils, EntityInfo } from '@record-it-npm/synchro-common';
import { EntityName } from '../../../EntityName';
import { CreateEntityInfoOptions } from '../../base/CreateEntityInfoOptions';
import { UserGroupSubEntityInfoUtils } from '../../base/UserGroupSubEntityInfoUtils';
import { TimeTrackingActivityDto } from './TimeTrackingActivityDto';
import { AppCommonSynchronizationEnvironmentTypes } from '../../../AppCommonSynchronizationEnvironment';

export function createTimeTrackingActivityEntityInfo<
  TEntity extends TimeTrackingActivityDto
>(
  options: CreateEntityInfoOptions<TimeTrackingActivityDto, TEntity>
): EntityInfo<
  AppCommonSynchronizationEnvironmentTypes,
  EntityName.TimeTrackingActivity,
  TEntity
> {
  return {
    entityName: EntityName.TimeTrackingActivity,
    synchronizeRelativeTo: [],
    trackGlobalRevision: true,
    fieldInfos: BaseEntityInfoUtils.createFieldInfos<
      AppCommonSynchronizationEnvironmentTypes,
      TimeTrackingActivityDto,
      TEntity
    >(
      {
        ...UserGroupSubEntityInfoUtils.createBaseFieldInfos(),
        name: {
          name: 'name',
          defaultValue: ''
        },
        parentActivityId: {
          name: 'parentActivityId',
          ref: EntityName.TimeTrackingActivity,
          cascadeDeleteLocally: true
        },
        compilationId: {
          name: 'compilationId',
          ref: EntityName.TimeTrackingActivityCompilation,
          cascadeDeleteLocally: true
        },
        order: {
          name: 'order'
        }
      },
      options.additionalFieldInfos
    )
  };
}
